export const PREZAO_VALUES = ["17", "24,99", "34,99"];
